export const Library = ({ color = "black", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
      style={{ color }}
    >
      <g id="famicons:library-outline">
        <path
          id="Vector"
          d="M3.75 4.5H2.25C1.83579 4.5 1.5 4.83579 1.5 5.25V21C1.5 21.4142 1.83579 21.75 2.25 21.75H3.75C4.16421 21.75 4.5 21.4142 4.5 21V5.25C4.5 4.83579 4.16421 4.5 3.75 4.5Z"
          stroke="currentColor"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M5.25 10.5H11.25M5.25 18.75H11.25"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M10.5 7.5H6C5.58579 7.5 5.25 7.83579 5.25 8.25V21C5.25 21.4142 5.58579 21.75 6 21.75H10.5C10.9142 21.75 11.25 21.4142 11.25 21V8.25C11.25 7.83579 10.9142 7.5 10.5 7.5Z"
          stroke="currentColor"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M15.75 2.25H12.75C12.3358 2.25 12 2.58579 12 3V21C12 21.4142 12.3358 21.75 12.75 21.75H15.75C16.1642 21.75 16.5 21.4142 16.5 21V3C16.5 2.58579 16.1642 2.25 15.75 2.25Z"
          stroke="currentColor"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M19.8027 4.50518L17.909 4.7044C17.3877 4.75924 17.0099 5.24674 17.0685 5.78721L18.7054 20.8617C18.7644 21.4022 19.2383 21.7992 19.7596 21.7449L21.6533 21.5456C22.1746 21.4908 22.5524 21.0033 22.4938 20.4628L20.8593 5.39065C20.7979 4.84784 20.324 4.45034 19.8027 4.50518Z"
          stroke="currentColor"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
